import React from 'react';

import Banner from '@/components/Base/Banner';

// import ContentZone from '@/components/Base/ContentZone';
// import { CONTENT_POSITION_TYPES } from '@/constants';
// import { useGetContentBlocks } from '@/hooks';
import Wrapper from './PageSidebar.styles';

function PageSidebar() {
  // const {
  //   contentBlocks: {
  //     [CONTENT_POSITION_TYPES.asideTop]: asideTopContent,
  //     [CONTENT_POSITION_TYPES.asideBottom]: asideBottomContent,
  //   },
  // } = useGetContentBlocks();

  return (
    <Wrapper id="mc-sidebar">
      {/* <ContentZone */}
      {/*  content={asideTopContent} */}
      {/*  position={CONTENT_POSITION_TYPES.asideTop} */}
      {/* /> */}

      <Banner id="hp-react-banner-premium" slot="bn-slot-premium" />

      {/* <ContentZone */}
      {/*  content={asideBottomContent} */}
      {/*  position={CONTENT_POSITION_TYPES.asideBottom} */}
      {/* /> */}
    </Wrapper>
  );
}

export default PageSidebar;
